// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__lkpIZ","left":"Virtual_left__upc2b","wrapper":"Virtual_wrapper__jXJa4"};